import { IntlShape } from "react-intl"
import { BenchmarkDetail } from "../interfaces"

export const getCssForValue = (value: number) => {
	if (value === 0) return ""

	return Math.sign(value) > 0 ? "total-positive" : "total-negative"
}

export const generateColumnsHeader = (
	tableHeaders: Array<string>,
	levelName: string,
	intl: IntlShape
) => {
	const levelHeader = {
		name: intl.formatMessage({
			id: `phronesis.transactional.application.commercial.benchmark.title.first.column.${levelName}`,
		}),
		alignment: "left",
		nameColumnSort: "name",
		hasSort: true,
		className: "first-header-column",
	}

	const headers = tableHeaders.map((header: string) => {
		return {
			name: intl.formatMessage({
				id: `phronesis.performance.application.switching.benchmark.description.${header}.column`,
			}),
			alignment: "right",
			nameColumnSort: header,
			hasSort: true,
		}
	})

	headers.unshift(levelHeader)

	return headers
}

const levelMessageIndex: Record<string, string> = {
	["department"]: "department",
	["category"]: "category",
	["subcategory"]: "category",
	["fineline"]: "subcategory",
}

export const getLevelNameMessageId = (
	levelName: string,
	fatherLevelName: string
) => {
	if (levelName === "fineline" && fatherLevelName === "fineline") {
		return levelName
	}
	return levelMessageIndex[levelName]
}

export const getSwitchingBenchmarkTitle = (
	levelName: string,
	fatherLevelName: string
) => {
	return `phronesis.performance.application.switching.benchmark.${getLevelNameMessageId(
		levelName,
		fatherLevelName
	)}.title`
}

export const isNotEmpty = (text: string) => text?.length > 0

export const hasValidData = (details: Array<BenchmarkDetail>) => {
	const totalProfits = details.reduce((total, detail) => {
		return total + detail.profits
	}, 0)
	const totalLosses = details.reduce((total, detail) => {
		return total + detail.losses
	}, 0)

	return !(totalProfits == 0 && totalLosses == 0)
}
